export const menuConstants = {
    GET_MENU_SUCCESS: 'GET_MENU_SUCCESS',
    GET_MENU_ERROR: 'GET_MENU_ERROR',
    TOGGLE_MENU: 'TOGGLE_MENU',
    TOGGLE_TODO_MENU: 'TOGGLE_TODO_MENU',
    TOGGLE_NEWSLETTER: 'TOGGLE_NEWSLETTER',
}
